import { render } from "./TextFieldComponent.vue?vue&type=template&id=b4ac4e7a&scoped=true"
const script = {}

import "./TextFieldComponent.vue?vue&type=style&index=0&id=b4ac4e7a&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/apps/synergy-login/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ac4e7a"]])

export default __exports__